import React, {useEffect, useState} from 'react'
import './style.scss'
import Modal from 'react-responsive-modal'
import CustomInput from "../../../organizer/components/custom/CustomInput";
import {Button} from "rsuite";
import axios from "axios";
import {toast} from "react-toastify";
import Loader from "../../Loader";


export default function InviteTextGenerator(
    {
        show,
        setShow,
        initialText = '',
        weddingData,
        onSaveData,
        language = null
    }
) {

    const [prompt, setPrompt] = useState(initialText)
    const [results, setResults] = useState([])

    const [generateLoading, setGenerateLoading] = useState(false)

    useEffect(() => {

        if(show === false) {
            setTimeout(() => {
                setPrompt('')
                setResults([])
            }, 500)

        }

        // eslint-disable-next-line
    }, [show])


    const generateText = async () => {

        if (!prompt || prompt.length < 5) {
            toast.warn('Vă rugăm introduceți cel puțin 5 caractere.')
            return
        }

        setGenerateLoading(true)

        let auth = {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem('jwt')
            }
        }

        console.log(language)

        let obj = {
            id_eveniment: weddingData.id_eveniment,
            prompt: prompt.trim().toLocaleLowerCase(),
            language: (!language || language.length === 0) ?
                weddingData && weddingData.invite && weddingData.invite.language ? weddingData.invite.language : 'ro' : language
        }

        await axios.post(process.env.REACT_APP_DOMAIN + 'weddings/text-generator/generateWeddingInvitePhrase', obj, auth)
            .then((response) => {
                if(response && response.data && response.data.error && response.data.error === 'limit_reached') {
                    toast.error('Ne pare rău! Ați atins limita maximă de utilizare a acestui serviciu!')
                } else {
                    if (response && response.data && response.data.data && response.data.data.result && response.data.data.result.length > 0) {
                        setResults(response.data.data.result)
                    }
                }
            })
            .catch(err => {
                toast.error('A apărut o eroare! Vă rugăm reîncercați!')
            })

        setGenerateLoading(false)

    }


    return (<>
            <Modal classNames={{
                overlay: 'modal-overlay',
                modal: 'modal-no-top',
                closeButton: 'modal-close-button',
            }} open={show} focusTrapped={false} onClose={() => setShow(false)}>

                <div className={"invite-text-generator-modal"}>
                    <p>Generează conținut</p>

                    <div className={"title"}>Spune-ne ce vrei să transmiți, iar noi îți generăm texte adaptate perfect pentru invitația ta digitală.</div>
                    <CustomInput
                        value={prompt}
                        onChange={(value) => setPrompt(value)}
                        placeholder={"ex: ziua in care ne-am cunoscut"}
                        componentClass={"textarea"}
                        style={{marginBottom:'5px', marginTop:'5px'}}
                    />

                    <Button
                        onClick={() => {
                            generateText()
                        }}
                        color="green"
                        disabled={generateLoading}
                        style={{
                            backgroundColor: "#05aff2",
                            borderRadius: "20px",
                            width: "100%",
                            marginTop: "0",
                            marginBottom: "10px"
                        }}>Generează</Button>


                    {generateLoading ?
                        <Loader/> : null}

                    {results && results.length > 0 ?
                        <>
                            <p className={"results-title"}>Alege-ți unul dintre rezultate sau reîncercați</p>
                            <div className={"results"}>
                                {results.map((result, key) => (
                                    <div key={key} className={"result-item"} onClick={() => {
                                        onSaveData(result)
                                        setResults([])
                                        setShow(false)
                                    }}>
                                        {result}
                                    </div>
                                ))}
                            </div>
                        </> : null}
                </div>


            </Modal>

        </>
    )

}
